import axios, { AxiosPromise } from 'axios';

export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_PENDING = `${SIGN_IN}_PENDING`;
export const SIGN_IN_FULFILLED = `${SIGN_IN}_FULFILLED`;
export const SIGN_IN_REJECTED = `${SIGN_IN}_REJECTED`;

interface AxiosPromiseResponse {
  data: any;
  statusCode: string;
  myDishMessageId: string;
  messages?: [
    {
      type: 'info' | 'warning' | 'error' | 'success';
      cmsTemplate: string;
      cmsField: string;
      cmsContentId: string;
      defaultMessage: string;
    }
  ];
}

interface SignInAction {
  type: typeof SIGN_IN;
  payload: AxiosPromise<AxiosPromiseResponse>;
  meta?: any;
}

export interface SignInResponse {
  type: string;
  payload: AxiosPromiseResponse;
  meta?: any;
}

export interface SignInRequest {
  username: string;
  password: string;
  rememberMeCheck: string;
  captchaToken: string;
}

export function signIn(signInRequest: SignInRequest): SignInAction {
  const request = {
    username: signInRequest.username,
    password: signInRequest.password,
    rememberMe: signInRequest.rememberMeCheck
  };
  return {
    type: SIGN_IN,
    payload: axios.post(`${process.env.REACT_APP_SIGNIN_ENDPOINT}`, request, {
      headers: {
        'Customer-Facing-Tool': "CSAWEB",
        CFT: "CSAWEB",
        'captcha-token': signInRequest.captchaToken,
        'captcha-flow': 'LOGIN' // TODO get this value dynamically from parameter
      }
    })
  };
}
